import { ArrowLeft } from "lucide-react";
import { Link } from "react-router";

interface EnlaceVolverProps {
  to: string;
  children: React.ReactNode;
}

/**
 * Enlace "volver" de las pantallas de alta/edición (flecha + rótulo).
 *
 * Estaba copiado con sus clases en cada formulario: al tercero, cualquier
 * ajuste de estilo quedaba a medio aplicar. Es un solo elemento, pero es UN
 * elemento del sistema.
 */
export function EnlaceVolver({ to, children }: EnlaceVolverProps) {
  return (
    <Link
      to={to}
      className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5 text-sm font-semibold"
    >
      <ArrowLeft className="h-3.5 w-3.5" />
      {children}
    </Link>
  );
}
